// Real MBFitApi calls (see MBFitApi repo, running at http://localhost:5000):
//   POST /api/auth/login        (MBFitApi.Api/Controllers/AuthController.cs)
//     body: LoginRequest { emailOrUsername, password }
//     returns: AuthResponse { userId, email, name, accessToken, refreshToken, accessTokenExpiresAt }
//     Note: this endpoint returns AuthResponse directly, NOT wrapped in the
//     ApiResponse envelope the /api/admin/* endpoints use.
//   POST /api/auth/refresh      body: { refreshToken } -> AuthResponse (yeni access + refresh token).
//     apiClient bunu 401 alınca otomatik çağırır; refresh token tek kullanımlıktır.
//   GET  /api/admin/auth/me     (MBFitApi.Api/Controllers/Admin/AdminAuthController.cs)
//     header: Authorization: Bearer {accessToken}
//     returns: ApiResponse<AdminMeResponse> -> data: { userId, email, role, lastLoginAt }
//   POST /api/admin/auth/change-password
//     body: AdminChangePasswordRequest { currentPassword, newPassword, confirmNewPassword }
//     returns: ApiResponse (data yok). Başarılı olursa adminin refresh token'ları iptal edilir.
//
// /api/auth/login itself doesn't gate by role — it's shared with the mobile
// app, so any valid MB Fit account can log in there. Admin-panel access is
// enforced by /api/admin/auth/me instead, which 403s a token whose role
// isn't Admin or SuperAdmin (see AuthContext.login, which calls both in
// sequence).
import { apiClient } from "../../../utils/apiClient";

export const authService = {
  /** POST /api/auth/login */
  async login({ emailOrUsername, password }) {
    return apiClient.post("/api/auth/login", { emailOrUsername, password }, { token: null });
  },

  /**
   * GET /api/admin/auth/me. Token verilmezse saklı oturum kullanılır; süresi dolmuşsa apiClient
   * refresh token ile yeniler.
   */
  async me(accessToken) {
    const response = await apiClient.get("/api/admin/auth/me", { token: accessToken });
    return response.data;
  },

  /** POST /api/admin/auth/change-password */
  async changePassword({ currentPassword, newPassword, confirmNewPassword }) {
    return apiClient.post("/api/admin/auth/change-password", { currentPassword, newPassword, confirmNewPassword });
  },
};
